// DS: DS6.1, DS6.1.3 (with prop isInteractive = false)
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useEffect, useRef, useCallback } from 'react';
import c from 'classnames';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import RadioButton from '../../RadioButton';
import Flex from '../../Flex';
import Checkbox from '../../Checkbox';
import s from './ListItem.scss';
/** @deprecated Use an appropriate component from ./dsPresets/ instead */ const ListItem = (_param)=>{
    var { label , subLabel , boldLabel , prefix , suffix , suffixIcon: SuffixIcon , bottomSlot , isInteractive =true , isSelected , isDisabled , control: controlFromProps , fillContainerWidth , noLeftPadding , alignItemsCenter , showSuffixOnlyOnHover , biData , onClick , onChange , className , value , name , focused , href , target  } = _param, rest = _object_without_properties(_param, [
        "label",
        "subLabel",
        "boldLabel",
        "prefix",
        "suffix",
        "suffixIcon",
        "bottomSlot",
        "isInteractive",
        "isSelected",
        "isDisabled",
        "control",
        "fillContainerWidth",
        "noLeftPadding",
        "alignItemsCenter",
        "showSuffixOnlyOnHover",
        "biData",
        "onClick",
        "onChange",
        "className",
        "value",
        "name",
        "focused",
        "href",
        "target"
    ]);
    const control = typeof href !== 'undefined' ? 'link' : controlFromProps;
    const itemRef = useRef(null);
    const setItemRef = useCallback((node)=>{
        itemRef.current = node;
    }, []);
    useEffect(()=>{
        if (itemRef.current && focused) {
            itemRef.current.focus({
                preventScroll: true
            });
        }
    }, [
        itemRef,
        focused
    ]);
    const onChangeHandler = ()=>{
        if (onChange) {
            onChange(!isSelected, value);
        } else if (onClick) {
            onClick();
        }
    };
    const ItemContent = /*#__PURE__*/ React.createElement("div", {
        className: s['fill-container-width']
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "row",
        alignItems: "center"
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        justifyContent: "center",
        className: s['central-area']
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['label'], boldLabel && s['bold-label'])
    }, label), subLabel && /*#__PURE__*/ React.createElement("div", {
        className: s['sub-label']
    }, subLabel)), (suffix || SuffixIcon) && /*#__PURE__*/ React.createElement("div", {
        className: s['suffix']
    }, suffix, SuffixIcon && /*#__PURE__*/ React.createElement(SuffixIcon, {
        size: IconSize.MEDIUM,
        className: s['suffix-icon'],
        disableDefaultColors: true
    }))), bottomSlot && /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-slot']
    }, bottomSlot));
    const wrapperClassnames = c(s['root'], isInteractive && s['interactive'], isSelected && s['selected'], isDisabled && s['disabled'], noLeftPadding && s['no-left-padding'], alignItemsCenter && s['align-items-center'], control === undefined && s['no-control'], control === 'radiobutton' && s['radio-margin'], fillContainerWidth && s['fill-container-width'], showSuffixOnlyOnHover && s['suffix-on-hover'], className);
    // Radio buttons allow an onClick handler to be passed directly.
    // This way we can catch click events on the radio button even when it's already selected.
    if (control === 'radiobutton') {
        return /*#__PURE__*/ React.createElement(RadioButton, _extends({
            name: name || '',
            value: value || '',
            className: wrapperClassnames,
            onChange: onChange && (()=>onChange(!isSelected, value)),
            onClick: onClick,
            biData: biData,
            checked: isSelected,
            tabIndex: 0
        }, rest), ItemContent);
    }
    if (control === 'checkbox') {
        return /*#__PURE__*/ React.createElement(BiDiv, {
            biData: biData,
            className: wrapperClassnames,
            onClick: onChangeHandler,
            innerRef: setItemRef,
            tabIndex: 0
        }, /*#__PURE__*/ React.createElement(Checkbox, _extends({
            role: "checkbox",
            "aria-checked": isSelected,
            className: s['checkbox'],
            onChange: onChangeHandler,
            biData: biData,
            isChecked: isSelected,
            id: name
        }, rest)), ItemContent);
    }
    if (control === 'link') {
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({
            className: wrapperClassnames,
            href: href,
            target: target,
            onClick: onChangeHandler,
            biData: biData,
            innerRef: setItemRef,
            tabIndex: 0
        }, rest // mildly disgusting but react is being weird
        ), ItemContent);
    }
    return /*#__PURE__*/ React.createElement(BiDiv, _extends({
        className: wrapperClassnames,
        onClick: onChangeHandler,
        biData: biData,
        innerRef: setItemRef,
        tabIndex: 0
    }, rest), ItemContent);
};
ListItem.displayName = 'ListItem';
export default ListItem;
